import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { lastValueFrom, Subject, takeUntil } from "rxjs";
import { SubidaDocumentoComponent } from "src/app/components/subida-documento/subida-documento";
import { LoteCertificadoComponent } from "src/app/components/lote-certificado/lote-certificado";
import { AsociacionFirmaComponent } from "src/app/components/asociacion-firma-documento/asociacion-firma-documento.component";
import { LoteCertificadoService } from "src/app/core/services/lote-certificado.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { LoteDetalleUrlService } from "src/app/core/services/lote-detalle-url.service";
import { LoteService } from "src/app/core/services/lote.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { IntegracionServices } from "src/app/core/services/integraciones.service";
import { Lote } from "src/app/models/Lote.model";
import { k } from "src/environments/properties";
import { LoteCertificado } from "src/app/models/LoteCertificado.model";
import { LoteDetalleUrl } from "src/app/models/LoteDetalleUrl.model";
import { PlantillasService } from "src/app/core/services/plantilla.service";
import { Plantilla } from "src/app/models/Plantilla.model";
import { LoadingService } from "src/app/core/services/loading.service";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { HelpToursService } from "src/app/core/tours/help-tours.service";

@Component({
  selector: "app-batch-configuration-externa",
  templateUrl: "./batch-configuration-externa.component.html",
  styleUrls: ["./batch-configuration-externa.css"],
})
export class BatchConfigurationExternaComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Output() firmaChangeStepper: EventEmitter<any> = new EventEmitter<any>();
  @Output() validateModuleUser: EventEmitter<any> = new EventEmitter<any>();

  batchConfigForm: FormGroup;
  private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente
  idLote: any = null; // Para almacenar el ID del lote
  public loteCertificados: LoteCertificado[] = [];
  public plantillas: Plantilla[] = [];
  lote: Lote;
  public loteCertificados2: LoteCertificado[] = [];

  public ListExterno: any = [];
  public servicioExterno: any = [];
  public listFlujo: any = [];
  public endpointSeleccionado: string = "";
  public total_contrtos: number = 0;
  public plantilla_precalibrada: boolean = false;
  public idFlujo: string = "";
  @Output() cantidadDocumentosChange = new EventEmitter<number>();
  @Output() step1ConfirmedChange = new EventEmitter<boolean>();


  @ViewChild(SubidaDocumentoComponent)
  subidaDocumentoComponent!: SubidaDocumentoComponent;
  @ViewChild(LoteCertificadoComponent)
  loteCertificadoComponent!: LoteCertificadoComponent;
  @ViewChild(AsociacionFirmaComponent)
  asociacionFirmaComponent!: AsociacionFirmaComponent;
  @ViewChild("modalAsignarExterno") modalAsignarExterno!: TemplateRef<any>;
  // Toast
  toast = Swal;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private loteService: LoteService,
    private firmaStateService: FirmaStateService,
    private router: Router,
    private route: ActivatedRoute,
    private loteCertificadoService: LoteCertificadoService,
    private loteDetalleUrlService: LoteDetalleUrlService,
    private plantillaService: PlantillasService,
    private serviciosExternos: ServiciosService,
    private integracionServices: IntegracionServices,
    public loading: LoadingService,
    private tours: HelpToursService,
  ) {}
  ngOnDestroy(): void {
    this.tours.stop();
  }

  ngOnInit(): void {
    this.toastAlert();
    this.listServiciosExternos();

    // Inicializamos el formulario reactivo
    this.batchConfigForm = this.fb.group({
      titulo: ["", [Validators.required, Validators.minLength(3)]], // Título es requerido y debe tener al menos 3 caracteres
      notificacion_firmantes: [true], // Checkbox Notificar firma (valor inicial es false)
      firma_por_plantilla: [false],
      es_grupo: [false],
      renombrar_documentos: [false],
      id_plantilla: null,
      disco: ["local"],
      id_servicio_externo: ["", [Validators.required]],
      flujo: ["", [Validators.required]],
    });

    
    this.batchConfigForm.get("flujo")?.valueChanges.subscribe((value) => {
      if (value) {
        this.onFlujoChange(value);
      }
    });

    this.batchConfigForm
      .get("id_servicio_externo")
      ?.valueChanges.subscribe((value) => {
        if (value) {
          this.onServicioChange(value);
        }
      });

    this.route.paramMap
      .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
      .subscribe(async (params) => {
        // 'id' es el nombre del parámetro definido en tu configuración de rutas
        // Por ejemplo: path: 'firmas/firma/:id'
        const id = params.get("id");

        await this.getTemplates();
        if (Number(id)) {
          this.idLote = id; // El '+' convierte el string a número

          // procedemos a precargar la data de los pasos
          await this.precargarData(this.idLote);
          await this.validateUserModule();
        } else {
          this.idLote = null;
        }
      });

    this.initReactions();
    this.listenEsGrupoChanges();
  }

  ngAfterViewInit(): void {
    this.onHelp();
  }

  onHelp(force = false) {
    this.tours.start("step1_create_lote_help", force);
  }

  initReactions() {
    const firmaPorPlantillaCtrl = this.batchConfigForm.get(
      "firma_por_plantilla",
    );
    const esGrupoCtrl = this.batchConfigForm.get("es_grupo");
    const idPlantillaCtrl = this.batchConfigForm.get("id_plantilla");

    // ✅ Cuando cambia "Firma por plantilla"
    firmaPorPlantillaCtrl?.valueChanges.subscribe((checked: boolean) => {
      if (checked) {
        // 1) Plantilla requerida
        idPlantillaCtrl?.setValidators([Validators.required]);
        idPlantillaCtrl?.updateValueAndValidity();

        // 2) Apagar "es_grupo"
        esGrupoCtrl?.setValue(false, { emitEvent: false });
      } else {
        // Quitar required y limpiar valor
        idPlantillaCtrl?.clearValidators();
        idPlantillaCtrl?.setValue(null, { emitEvent: false });
        idPlantillaCtrl?.updateValueAndValidity();
      }
    });

    // ✅ Cuando cambia "Es grupo"
    esGrupoCtrl?.valueChanges.subscribe((checked: boolean) => {
      if (checked) {
        // Apagar "firma_por_plantilla" y limpiar plantilla
        firmaPorPlantillaCtrl?.setValue(false, { emitEvent: false });

        idPlantillaCtrl?.clearValidators();
        idPlantillaCtrl?.setValue(null, { emitEvent: false });
        idPlantillaCtrl?.updateValueAndValidity();
      }
    });
  }

  private listenEsGrupoChanges(): void {
    this.batchConfigForm
      .get("es_grupo")
      ?.valueChanges.subscribe((esGrupo: boolean) => {
        if (!esGrupo) {
          this.batchConfigForm.get("renombrar_documentos")?.setValue(false, {
            emitEvent: false,
          });
        }
      });
  }

  async precargarData(id: number): Promise<any> {
    this.lote = this.firmaStateService.getCurrentState()?.lote;

    let configuracion = null;
    configuracion = await this.showConfiguracionLote();
    if (!this.lote) {
      // sino hemos precargado anteriormente nuestro estado global procedemos a cargar y redireccionar el stepper

      this.lote = (await this.showLote(id)) as Lote;
      this.loteCertificados2 = (await this.indexLoteCertificado(id))
        .body as LoteCertificado[];
      const loteDetalleUrl = await this.indexLoteDetalleUrl();

      this.firmaStateService.updateLote(this.lote as Lote);
      this.firmaStateService.updateLoteCertificado(this.loteCertificados2);
      let stepper = 1;
      if (this.lote.estado.nombre_corto == "FAL") stepper = 1;
      if (loteDetalleUrl.length) stepper = 2;
      if (await this.validateLoteCertificado()) stepper = 3;
      if (
        this.lote.estado.nombre_corto == "SDF" ||
        this.lote.estado.nombre_corto == "EPC"
      )
        stepper = 4;
      this.firmaChangeStepper.emit(stepper);
    }

    await this.onServicioChange(configuracion?.lote?.id_servicio_externo);

    this.batchConfigForm.patchValue({
      disco: this.lote?.disco,
      titulo: this.lote?.titulo,
      notificacion_firmantes: this.lote.notificacion_firmantes,
      firma_por_plantilla: this.lote?.firma_por_plantilla,
      es_grupo: this.lote?.es_grupo,
      renombrar_documentos: this.lote?.renombrar_documentos,
      id_plantilla: this.lote?.plantilla?.id ? this.lote?.plantilla?.id : "",
      id_servicio_externo: configuracion?.lote?.id_servicio_externo,
      flujo: configuracion?.id_item,
    });
  }
  // 86538a4b-7963-48e2-9f5c-4e6861ddb50f

  async indexLoteDetalleUrl() {
    const response = await lastValueFrom(
      this.loteDetalleUrlService.indexDetalleUrl(this.idLote),
    );
    return response.body as LoteDetalleUrl[];
  }

  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }

  async indexLoteCertificado(id: number) {
    const response = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificado(id),
    );
    return response;
  }

  onChangeFirmaPorPlantillaCheck(event: Event) {
    const input = event.target as HTMLInputElement;
  }

  onChangeFirmaEsGrupoCheck(event: Event) {
    const input = event.target as HTMLInputElement;
  }

  public async saveFormData(): Promise<boolean> {
    let msg = "";
    let lote = null;

    if (this.batchConfigForm.valid) {
      this.batchConfigForm.removeControl("flujo");
      const formValues = this.batchConfigForm.value;
      const estadoActual = this.lote?.estado?.nombre_corto;

      if (this.idLote && estadoActual !== "FAL") {
        await this.credentialCache();
        // PUT
        lote = (await lastValueFrom(
          this.loteService.updLote(formValues, this.idLote),
        )) as Lote;
        this.firmaStateService.updateLote(lote as Lote);
        msg = "¡Configuración actualizada!";
      } else {
        // POST
        if (!this.lote || estadoActual !== "FAL") {
          lote = (await lastValueFrom(
            this.loteService.post(formValues),
          )) as Lote;
          this.firmaStateService.updateLote(lote as Lote);
        }

        if (lote && estadoActual !== "FAL") {
          const payload = {
            nombre_corto_tipo_configuracion: "SDF",
            id_item: this.idFlujo,
          };
          await lastValueFrom(
            this.loteService.crearConfiguracionLote(lote.id, payload),
          );
        }

        await this.credentialCache();
        const lote_id = lote.id ? lote.id : this.idLote;
        try {
          const datos = {
            endpoint: this.endpointSeleccionado,
            datos: {
              id_lote: lote_id,
              nombre_corto: this.servicioExterno.nombre_corto,
              plantilla_precalibrada: this.plantilla_precalibrada,
              id_plantilla: this.batchConfigForm.value.id_plantilla,
            },
          };
          const response: any = await lastValueFrom(
            this.integracionServices.saveSistemaExterno(
              datos,
              this.servicioExterno.nombre_corto,
            ),
          );
          if (response) {
            this.router.navigate([`firmas/firma-externa/${lote_id}`]); // Ejemplo: de /lotes/new a /lotes/31
            msg = "¡Configuración agregada!";
          }
        } catch (error) {
          this.cambioEstado();
          this.router.navigate([`firmas/firma-externa/${lote_id}`]);
        }
      }

      if (lote) {
        this.alert("success", msg);
        return true;
      } else {
        return false;
      }
    } else {
      this.batchConfigForm.markAllAsTouched(); // Marcar para mostrar errores al usuario
      return false; // Indica que el guardado falló debido a la validación
    }
  }

  async validateUserModule() {
    const response = this.firmaStateService.getCurrentState().lote_certificado;
    const usuarioCreacion =
      this.firmaStateService.getCurrentState().lote?.usuario; // Usuario que creo el lote

    const lista = Array.isArray(response)
      ? (response as LoteCertificado[])
      : [];
    this.loteCertificados = lista;

    const userId = localStorage.getItem(k.user_id) ?? "";

    let existe = false;

    //Si el usuario de la sesión, es el mismo que creo el lote
    existe = usuarioCreacion.id == userId;

    //Si no es quien creo el lote, se valida que sea uno de los usuarios firmantes
    if (this.loteCertificados.length > 0 && !existe) {
      //Se valida que el usuario existe dentro de los firmantes asociados al lote
      existe = lista.some((crt) => String(crt?.usuario?.id) === String(userId));
    }
    this.validateModuleUser.emit(existe);
  }

  async getTemplates() {
    const response = await lastValueFrom(
      this.plantillaService.getPlantillas(100, 100),
    );

    if (response?.body) {
      this.plantillas = response?.body;
    } else {
      this.plantillas;
    }
  }

  async validateLoteCertificado() {
    // Validación principal (siempre)
    if (this.loteCertificados2.length === 0) {
      // this.alert('warning', 'Debe agregar certificados antes de continuar.');
      return false;
    }

    // Validación adicional solo para firma por plantilla
    if (this.lote.firma_por_plantilla) {
      const validarGrupo = await this.validar();

      if (!validarGrupo) {
        this.alert(
          "warning",
          "Debe asociar todos los certificados antes de continuar.",
        );
        return false;
      }
    }

    return true;
  }

  async validar() {
    let sinAsignar = this.loteCertificados2.find((x: any) => {
      return (
        x.loteDetalleUrlCoordenada &&
        Array.isArray(x.loteDetalleUrlCoordenada) &&
        x.loteDetalleUrlCoordenada.length == 0
      );
    });

    return sinAsignar ? false : true;
  }

  //SERVICIOS EXTERNOS
  async listServiciosExternos() {
    let params = new HttpParams();
    params = params.set("pagination", true);
    const response = await lastValueFrom(
      this.serviciosExternos.getServicios(params),
    );

    const data = response.body ?? [];
    this.ListExterno = data.map((x: any) => {
      return {
        nombre: x.nombre,
        nombre_corto: x.nombre_corto,
        id: x.id,
      };
    });
  }

  async buscarServicioExterno(openModal:boolean = true) {
    const flujo = this.batchConfigForm.get("flujo")?.value;

    if (flujo) {
      const datos = {
        endpoint: this.endpointSeleccionado,
        datos: {},
        metodo: "GET",
      };
      const response: any = await lastValueFrom(
        this.integracionServices.saveSistemaExterno(
          datos,
          this.servicioExterno.nombre_corto,
        ),
      );
      

      if (response) {
        this.total_contrtos = response.total_contratos;
        this.step1ConfirmedChange.emit(true);
        this.cantidadDocumentosChange.emit(this.total_contrtos);

        if(openModal){
          this.openModal(this.modalAsignarExterno);
        }        
      }
    } else {
      this.alert(
        "warning",
        "Campo requerido",
        "Debe seleccionar un flujo externo para realizar la busqueda",
      );
    }
  }

  async credentialCache() {
    const response: any = await lastValueFrom(
      this.integracionServices.creadencialesCache(
        this.servicioExterno.nombre_corto,
      ),
    );
    return response;
  }

  async showServicio(id: string) {
    const response = await lastValueFrom(
      this.serviciosExternos.showServicios(id),
    );
    const servicio = response.body;

    if (this.idLote == null) {
      this.batchConfigForm.patchValue({
        disco: servicio?.servicioExternoStorageConfigPredeterminado?.proveedor,
        flujo: servicio?.idServicioExternoFlujoPredeterminado,
      });
    }
  }

  async onServicioChange(idServicio: string | null) {
    const servicio = this.batchConfigForm.get("id_servicio_externo")?.value;
    this.servicioExterno = this.findInList(this.ListExterno, "id", servicio);
    
    if (idServicio) {
      await this.getListFlujos(idServicio);
      await this.showServicio(idServicio);
    }
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true, size: "lg" });
  }

  findInList<T>(list: T[], key: keyof T, value: any): T | undefined {
    if (
      !list?.length ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return undefined;
    }

    return list.find((item) => item[key] === value);
  }

  findConfiguracionByNombreCorto(
    list: any[],
    nombreCorto: string,
  ): any | undefined {
    if (!list?.length || !nombreCorto) {
      return undefined;
    }

    return list.find(
      (item: any) => item.tipoConfiguracion?.nombre_corto === nombreCorto,
    );
  }

  async getListFlujos(id: string) {
    const response = await lastValueFrom(
      this.serviciosExternos.getListFlujos(id),
    );
    this.listFlujo = response.body;
  }

  async onFlujoChange(id: string | null) {
    if (id) {
      this.idFlujo = id;
      const endpoint: any = this.findInList(this.listFlujo, "id", id)
        ? this.findInList(this.listFlujo, "id", id)
        : "";
      this.endpointSeleccionado = endpoint.endpoint;
      this.plantilla_precalibrada = endpoint.plantilla_precalibrada
        ? endpoint.plantilla_precalibrada
        : this.plantilla_precalibrada;

      await this.buscarServicioExterno(false);
    }
  }

  async cambioEstado() {
    const response = await lastValueFrom(
      this.loteService.cambioEstado(this.idLote, { nombre_corto: "FAL" }),
    );
  }

  async showConfiguracionLote() {
    const response = await lastValueFrom(
      this.loteService.showConfiguracionLote(this.idLote),
    );

    const configuracion = this.findConfiguracionByNombreCorto(
      response.body,
      "SDF",
    );

    return configuracion;
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }
}
